import AttachmentResource from '@/api/resources/attachment/attachmentResource'

class AttachmentTypeService extends AttachmentResource {
    async getAttachmentTypes(attachmentEntityType) {
        if (!ATTACHMENT_TYPES[attachmentEntityType]) {
            const params = { 'entity': attachmentEntityType }
            const response = await this.axios.get(`/common/attachmenttypes`, { params })
            const types = []
            response.data.forEach(type => types.push(type))
            ATTACHMENT_TYPES[attachmentEntityType] = types
        }
        return ATTACHMENT_TYPES[attachmentEntityType]
    }

    async getAttachmentType(attachmentEntityType, attachmentTypeCode) {
        const attachmentTypes = await this.getAttachmentTypes(attachmentEntityType)
        return attachmentTypes.find(attachmentType => {
            return attachmentType.atyCode === attachmentTypeCode
        })
    }
}

export const ATTACHMENT_TYPES = {
    INFORMED_CONSENT: 'attachment.type.informedconsent.code',
    PATIENT_INFO: 'attachment.type.patientinfo.code',
    REQUISITION: 'attachment.type.requisition.code',
    CASE_REQUISITION: 'attachment.type.caserequisition.code',
    COMPREHENSIVE_DIAGNOSIS_AUDIO: 'attachment.type.comprehensivediagnosisaudio.code',
    MACROSCOPIC_IMAGE: 'attachment.type.macroscopicimage.code',
    MACRO_EXAMINATION_VIDEO: 'attachment.type.macroexaminationvideo.code',
    MACRO_EXAMNATION_AUDIO: 'attachment.type.macroexaminationaudio.code',
    MICRO_EXAMINATION_AUDIO: 'attachment.type.microexaminationaudio.code',
    DIAGNOSIS_EXAMINATION_AUDIO: 'attachment.type.diagnosisexaminationaudio.code',
    ADDITIONAL_REPORT_AUDIO: 'attachment.type.additionalreportaudio.code',
    CASETTE_IMAGE: 'attachment.type.cassetteimage.code',
    MICROSCOPIC_IMAGE: 'attachment.type.microscopicimage.code',
    COMPLEMENTARY_INFORMATION_AUDIO: 'attachment.type.complementaryinformationaudio.code',
    SYNOPTICTEMPLATE_EXTERNALDOCUMENTATION: 'attachment.type.synoptictemp_extdoc.code',
    USERAPP_PROFILEIMAGE: 'attachment.type.userapp_profileimage.code',
    LABORATORY_LOGO: 'attachment.type.laboratory_logo.code',
    LABORATORY_REPORT_LOGO: 'attachment.type.laboratory_report_logo.code',
    OTHER: 'attachment.type.other.code'
}

export const ATTACHMENT_MIME_TYPES = {
    PLAIN_TEXT: 'text/plain',
    MSWORD: 'application/msword',
    EXCEL: 'application/vnd.ms-excel',
    ODT: 'application/vnd.oasis.opendocument.text',
    ODS: 'application/vnd.oasis.opendocument.spreadsheet',
    DOCX: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    PDF_DOCUMENT: 'application/pdf',
    URI: 'text/uri-list',
    IMAGE: 'image/',
    VIDEO: 'video/',
    AUDIO: 'audio/'
}

export default new AttachmentTypeService()
